export const MESSAGE_INTERVAL = 10000;
export const MESSAGE_TIMEOUT = 300;
